import React from 'react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { ReassuranceSection } from './components/ReassuranceSection';
import { ReasonSection } from './components/ReasonSection';
import { ImagineSection } from './components/ImagineSection';
import { MethodIntro } from './components/MethodIntro';
import { AcronymSection } from './components/AcronymSection';
import { ExperienceSection } from './components/ExperienceSection';
import { BonusesSection } from './components/BonusesSection';
import { ForYouSection } from './components/ForYouSection';
import { Imagine30Days } from './components/Imagine30Days';
import { StartToday } from './components/StartToday';
import { DayPreviewCarousel } from './components/DayPreviewCarousel';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalReflection } from './components/FinalReflection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-[#0A1535]" style={{
    backgroundColor: "#F7F2E7",
    backgroundImage: "none"
  }} data-id="element-0" data-mp="3mj6hjr46bqdc">
      <Hero data-id="element-1" data-mp="5ott78p769p" />
      <PainSection data-id="element-2" data-mp="6htxpd5ixiv" />
      <ReassuranceSection data-id="element-3" data-mp="4n4bxqxqh8g" />
      <ReasonSection data-id="element-4" data-mp="56qxrrj5tst" />
      <ImagineSection data-id="element-5" data-mp="2zl3azit8d249" />
      <MethodIntro data-id="element-6" data-mp="2zlli5ahfl0qy" />
      <AcronymSection data-id="element-7" data-mp="2zmepodo7rua5" />
      <ExperienceSection data-id="element-8" data-mp="2zmwggus3xgao" />
      <BonusesSection data-id="element-9" data-mp="33mouvo46mgny" />
      <ForYouSection data-id="element-10" data-mp="33m5eibu6k0c1" />
      <Imagine30Days data-id="element-11" data-mp="33ngdzzglelxc" />
      <StartToday data-id="element-12" data-mp="33myl9ct52pu6" />
      <DayPreviewCarousel data-id="element-13" data-mp="33oi152avuyvf" />
      <TestimonialsSection data-id="element-14" data-mp="38l8h7pmotugu" />
      <PricingSection data-id="element-15" data-mp="38l06o4e1f18t" />
      <GuaranteeSection data-id="element-16" data-mp="38nup5qdhqbzl" />
      <FaqSection data-id="element-17" data-mp="3dkus3sf1mymh" />
      <FinalReflection data-id="element-18" data-mp="3dle4ktlxcut4" />
      <Footer data-id="element-19" data-mp="3dlns8ajhypvn" />
    </div>;
}